import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAttendance, clockIn, clockOut } from '../store/attendanceSlice';

const AttendanceTerminal = () => {
  const dispatch = useDispatch();
  const { records, loading, error } = useSelector((state) => state.attendance);

  useEffect(() => {
    dispatch(fetchAttendance());
  }, [dispatch]);

  const handleClockIn = () => dispatch(clockIn());
  const handleClockOut = () => dispatch(clockOut());

  return (
    <div>
      <h2 style={{ color: '#1f2937' }}>Attendance Terminal</h2>
      <p style={{ marginBottom: '2rem', color: '#6b7280' }}>Mark your daily attendance quickly and easily.</p>

      {error && (
        <div style={{ background: '#fee2e2', color: '#ef4444', padding: '1rem', borderRadius: '8px', marginBottom: '1rem' }}>
          {error.error || 'Action failed.'}
        </div>
      )}
      
      <div className="card" style={{ display: 'flex', gap: '1rem', marginBottom: '3rem', padding: '2rem' }}>
        <button className="btn btn-success" onClick={handleClockIn} disabled={loading} style={{ flex: 1, padding: '1.5rem', fontSize: '1.25rem', borderRadius: '12px' }}>
          Clock In Now
        </button>
        <button className="btn btn-danger" onClick={handleClockOut} disabled={loading} style={{ flex: 1, padding: '1.5rem', fontSize: '1.25rem', borderRadius: '12px' }}>
          Clock Out
        </button>
      </div>

      <h3 style={{ color: '#1f2937', marginBottom: '1rem' }}>My Recent Attendance</h3>
      {loading && records.length === 0 ? <p style={{ color: '#6b7280' }}>Loading records...</p> : (
        <div className="card" style={{ padding: '0', overflow: 'hidden' }}>
          <table>
            <thead>
              <tr style={{ background: '#f9fafb' }}>
                <th>Date</th>
                <th>Clock In Time</th>
                <th>Clock Out Time</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {records.map(record => (
                <tr key={record.id}>
                  <td>{record.date}</td>
                  <td>{record.clock_in ? new Date(record.clock_in).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) : '-'}</td>
                  <td>{record.clock_out ? new Date(record.clock_out).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}) : '-'}</td>
                  <td>
                    {record.clock_in && !record.clock_out && <span style={{ color: 'var(--success)' }}>Active</span>}
                    {record.clock_out && <span style={{ color: 'var(--text-secondary)' }}>Completed</span>}
                  </td>
                </tr>
              ))}
              {records.length === 0 && (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '2rem' }}>No attendance records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AttendanceTerminal;
